import React, { useCallback, memo, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import { m as motion, useAnimation } from 'framer-motion'
import { useSetRecoilState } from 'recoil'
import {
  showService as showServiceState,
  selectedService as selectedServiceState,
  currentSection as currentSectionState,
} from '../../store/uiStore'

import { ServiceLinkButton } from '../../styles/servicesStyles'
import { ServiceOne, ServiceTwo } from '../../assets/svg/icons'

const ServiceLink = memo(
  React.forwardRef(({ index, title }, ref) => {
    const icons = [ServiceOne, ServiceTwo]
    const splitTitle = title.split(' ')
    const setShowService = useSetRecoilState(showServiceState)
    const setSelectedService = useSetRecoilState(selectedServiceState)
    const setCurrentSection = useSetRecoilState(currentSectionState)

    const serviceLinkVars = {
      hidden: {
        opacity: 0,
        y: '150%',
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          default: {
            duration: 1.5,
            ease: 'linear',
            delay: index * 0.5 + 1.25,
          },
          y: {
            duration: 1,
            type: 'anticipate',
            delay: index * 0.5 + 1.25,
          },
        },
      },
      exit: {
        opacity: 0,
        y: '150%',
        transition: {
          default: {
            duration: 1.5,
            ease: 'linear',
            delay: index * 0.15,
          },
          y: {
            duration: 1,
            type: 'anticipate',
            delay: index * 0.15,
          },
        },
      },
    }

    const serviceLinkDivVars = {
      hidden: {
        opacity: 0,
        transition: {
          duration: 1,
          delay: 0,
        },
      },
      visible: { opacity: 1 },
    }

    const serviceLinkAnims = useAnimation(serviceLinkVars)
    const serviceLinkDivAnims = useAnimation(serviceLinkDivVars)

    const handleServiceLink = useCallback(() => {
      setSelectedService(index)
      setShowService(true)
      setCurrentSection('servicio')
      /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [])

    useImperativeHandle(ref, () => ({
      playVisible() {
        serviceLinkAnims.start('visible')
        serviceLinkDivAnims.start('visible')
      },
      playHidden() {
        serviceLinkDivAnims.start('hidden')
        serviceLinkAnims.start('exit')
      },
    }))

    return (
      <ServiceLinkButton
        ref={ref}
        initial='hidden'
        animate={serviceLinkAnims}
        variants={serviceLinkVars}
        type='button'
        onClick={() => handleServiceLink()}>
        <motion.div
          className='icon'
          initial='hidden'
          animate={serviceLinkDivAnims}
          variants={serviceLinkDivVars}
          transition={{
            duration: 1,
            ease: 'easeOut',
            delay: index + 1 * 0.75,
          }}>
          {React.createElement(icons[index], null)}
        </motion.div>
        <div className='text'>
          {splitTitle.map((word, index) => (
            <span key={`service-link-${word}-${index}`}>{word}</span>
          ))}
        </div>
      </ServiceLinkButton>
    )
  })
)

ServiceLink.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
}

export default ServiceLink
